import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../translations';

const Benefits = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  const benefits = [
    {
      icon: '♻️',
      title: t.benefits.benefit1.title,
      description: t.benefits.benefit1.description,
    },
    {
      icon: '⏱️',
      title: t.benefits.benefit2.title,
      description: t.benefits.benefit2.description,
    },
    {
      icon: '🌍',
      title: t.benefits.benefit3.title,
      description: t.benefits.benefit3.description,
    },
    {
      icon: '📚',
      title: t.benefits.benefit4.title,
      description: t.benefits.benefit4.description,
    },
  ];

  return (
    <section className="bg-gradient-to-br from-gray-50 to-gray-100 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.benefits.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.benefits.subtitle}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 text-center"
            >
              <div className="text-5xl mb-4">{benefit.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;

